var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", [
      _c(
        "div",
        { staticClass: "relative inline-block text-left" },
        [
          _c("div", [
            _c("span", { staticClass: "rounded-md shadow-sm" }, [
              _c(
                "button",
                {
                  staticClass: "flex items-center rounded-full p-1 text-sm",
                  class: {
                    "text-yellow-800 hover:text-yellow-900 bg-yellow-100 ":
                      _vm.completedValue.completedFeatures <
                      _vm.completedValue.totalFeatures,
                    "text-green-400 hover:text-green-600":
                      _vm.completedValue.completedFeatures ===
                      _vm.completedValue.totalFeatures
                  },
                  on: {
                    click: function($event) {
                      _vm.isOpen = !_vm.isOpen
                    }
                  }
                },
                [
                  _c(
                    "svg",
                    {
                      staticClass: "h-5 w-5",
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        stroke: "currentColor",
                        "stroke-width": "2"
                      }
                    },
                    [
                      _c("path", {
                        attrs: {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                        }
                      })
                    ]
                  ),
                  _c("span", { staticClass: "tracking-widest" }, [
                    _vm._v(
                      " (" +
                        _vm._s(_vm.completedValue.completedFeatures) +
                        "/" +
                        _vm._s(_vm.completedValue.totalFeatures) +
                        ") "
                    )
                  ])
                ]
              )
            ])
          ]),
          _c(
            "transition",
            {
              attrs: {
                "enter-active-class":
                  "transition ease-out duration-100 transform",
                "enter-class": "opacity-0 scale-95",
                "enter-to-class": "opacity-100 scale-100",
                "leave-active-class":
                  "transition ease-in duration-75 transform",
                "leave-class": "opacity-100 scale-100",
                "leave-to-class": "opacity-0 scale-95"
              }
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isOpen,
                      expression: "isOpen"
                    }
                  ],
                  staticClass:
                    "origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg z-50 bg-white"
                },
                [
                  _c("div", { staticClass: "py-8 px-4" }, [
                    _c(
                      "nav",
                      {
                        staticClass: "flex justify-center",
                        attrs: { "aria-label": "Progress" }
                      },
                      [
                        _c(
                          "ol",
                          { staticClass: "space-y-6", attrs: { role: "list" } },
                          _vm._l(_vm.features, function(feature, index) {
                            return _c("li", { key: index }, [
                              _c(
                                "a",
                                {
                                  staticClass: "group cursor-pointer",
                                  on: {
                                    click: function($event) {
                                      return _vm.gotoRoute(feature.routeName)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "flex items-start" },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "flex-shrink-0 relative h-5 w-5 flex items-center justify-center"
                                        },
                                        [
                                          _vm.onboardingFlags &&
                                          _vm.onboardingFlags[feature.flag]
                                            ? _c(
                                                "svg",
                                                {
                                                  staticClass:
                                                    "h-full w-full text-indigo-600 group-hover:text-indigo-800",
                                                  attrs: {
                                                    xmlns:
                                                      "http://www.w3.org/2000/svg",
                                                    viewBox: "0 0 20 20",
                                                    fill: "currentColor",
                                                    "aria-hidden": "true"
                                                  }
                                                },
                                                [
                                                  _c("path", {
                                                    attrs: {
                                                      "fill-rule": "evenodd",
                                                      d:
                                                        "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
                                                      "clip-rule": "evenodd"
                                                    }
                                                  })
                                                ]
                                              )
                                            : _c("div", {
                                                staticClass:
                                                  "h-2 w-2 bg-gray-300 rounded-full group-hover:bg-gray-400"
                                              })
                                        ]
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "ml-3 text-sm font-medium text-gray-500 group-hover:text-gray-900"
                                        },
                                        [_vm._v(_vm._s(feature.label))]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ])
                          }),
                          0
                        )
                      ]
                    )
                  ])
                ]
              )
            ]
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }